import React, { useState,useContext } from 'react'
import { useForm } from "react-hook-form";
import GameContext from '../context/game/GameContext'
import { Link, useNavigate } from 'react-router-dom';

function Login(props) {
    const [showPassword, setshowPassword] = useState(false)
    let navigate = useNavigate()
    const host = "https://sudoku-backend.netlify.app/.netlify/functions"
    const { register, handleSubmit, formState: { errors } } = useForm({ mode: "all" });
    const context = useContext(GameContext)
    const { getuser } = context
    const onSubmit = async (data) => {
        const response = await fetch(`${host}/api/auth/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email: data.username, password: data.password })
        });
        const json = await response.json()
        if (json.Status) {
            localStorage.setItem('token', json.authtoken)
            getuser()
            navigate('/')
            // props.showAlert("Login Sucessfull", "Succes")
        }
        else {
            // props.showAlert("Invalid credentials", "danger")
        }
    }
    return (
        <div className='my-12 pb-32 flex justify-center items-center overflow-y-hidden'>
            <div className='lg:w-1/3 bg-red-100 rounded-lg shadow-xl'>
                <form className='shadow rounded w-full p-10' onSubmit={handleSubmit(onSubmit)}>
                    <p tabindex="0" className="focus:outline-none text-2xl font-extrabold leading-6 text-gray-800">Login to your account</p>
                    <p tabindex="0" className="focus:outline-none text-sm mt-4 font-medium leading-none text-gray-500">Dont have account?
                        <Link to='/signup' className="hover:text-gray-500 focus:text-gray-500 focus:outline-none focus:underline hover:underline text-sm font-medium leading-none  text-gray-800 cursor-pointer"> Sign up here</Link></p>

                    <span className='mt-3'>
                        <label htmlFor="username" className="text-sm font-medium leading-none text-gray-800" >Email</label>
                        <input
                            id="username"
                            type="email"
                            className="border-2 border-red-800 rounded  text-xs font-medium leading-none text-gray-800 py-3 w-full pl-3 mt-2"
                            {...register("username",
                                {
                                    required: "Please enter a valid username",
                                },)} />

                        {errors["username"] && <span className="inline-block w-full text-red-600 text-xs ml-1">{errors["username"].message}</span>}
                    </span>
                    <span className='mt-6  w-full'>
                        <label htmlFor="password" className="text-sm font-medium leading-none text-gray-800" >Password</label>
                        <div className='relative flex items-center justify-center'>
                            <input
                                id="password"
                                type={showPassword ? "text" : "password"}
                                className="border-2 border-red-800  rounded  text-xs font-medium leading-none text-gray-800 py-3 w-full pl-3 mt-2"
                                {...register("password",
                                    {
                                        required: "Please enter a valid passowrd",
                                    },)} />
                            <div className="absolute right-0 mt-2 mr-3 cursor-pointer">
                                <img src="https://tuk-cdn.s3.amazonaws.com/can-uploader/sign_in-svg5.svg" alt="viewport" onClick={() => { showPassword ? setshowPassword(false) : setshowPassword(true) }} />
                            </div>
                        </div>

                        {errors["password"] && <span className="inline-block w-full text-red-600 text-xs ml-1">{errors["password"].message}</span>}
                    </span>
                    <a className='ml-1 col-span-2 text-base mb-3 text-blue-700 hover:underline hover:text-blue-900' href="/">Forget password?</a>
                    <div className="mt-8">
                        <input className="focus:ring-2 focus:ring-offset-2 focus:ring-indigo-700 text-sm font-semibold leading-none text-white focus:outline-none bg-indigo-700 border rounded hover:bg-indigo-600 py-4 w-full" type="submit" value="Login" />
                    </div>
                
                </form>
            </div></div>

    )
}

export default Login
